import PropTypes from 'prop-types';
import logoBlue from 'assets/images/logo-blue.svg';
import accountManagementStrings from 'modules/accountManagement/strings';
import Loader from 'modules/common/components/Loader';
import SectionDivider from 'modules/common/components/SectionDivider';

import { Wrapper, Logo, FormValidationError, FormBtn } from './LoginComponent.style';

const LoginComponent = ({ isAuthenticating, authenticationError, handleSubmitBtnClick }) => (
  <Wrapper>
    <Logo src={logoBlue} />
    <SectionDivider gap={80} />
    {(isAuthenticating && <Loader width={30} height={30} thickness={5} />) || (
      <FormBtn as="button" disabled={isAuthenticating} onClick={() => handleSubmitBtnClick()}>
        {accountManagementStrings.login.formBtnText}
      </FormBtn>
    )}
    {authenticationError && (
      <>
        <SectionDivider gap={15} />
        <FormValidationError>{authenticationError}</FormValidationError>
      </>
    )}
  </Wrapper>
);
// ###############################################################
// <----------------------- End Return UI ----------------------->
// ###############################################################
LoginComponent.propTypes = {
  isAuthenticating: PropTypes.bool.isRequired,
  authenticationError: PropTypes.string,
  handleSubmitBtnClick: PropTypes.func.isRequired,
};

LoginComponent.defaultProps = {
  authenticationError: '',
};

export default LoginComponent;
